import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchUserTopVideos, resetUserTopVideos} from "../../../../creators/user.top.videos";

import Thumb from '../../../components/Thumb';
import {PageLoader} from "../../../components/Loader";
import Icon from "../../../components/Icon";
import {Link} from "react-router-dom";
import createLink from "../../../../libs/createLink";

class ProfileBestVideos extends React.Component {
    componentDidMount() {
        this.props.fetchUserTopVideos(this.props.user._id, {
            kind: "video",
            limit: 4,
            sort: "-count.like",
            isTotal: false
        });
    }

    componentWillUnmount() {
        this.props.resetUserTopVideos();
    }

    render() {
        return !this.props.userTopVideosInitialized ? (
            <div className={"card profil-best-medias"}>
                <PageLoader/>
            </div>
        ) : (
            <div className="card profil-best-medias">
                <div className="title">
                    Meilleures vidéos
                </div>
                {this.props.userTopVideosTotal > 0 ? (
                    <Fragment>
                        <div className="thumb-group">
                            {this.props.userTopVideos.map((item, index) => {
                                return (
                                    <Thumb
                                        key={index}
                                        {...item}
                                        miniatureOnly
                                        isMe={this.props.isMe}
                                    />
                                )
                            })}
                        </div>
                        <span className="see-more">
                            <Link
                                to={this.props.isMe ? createLink('userMeAlbums', this.props.user) : createLink('userAlbums', this.props.user)}>Toutes les vidéos</Link>
                            <Icon type="chevron-right"/>
                        </span>
                    </Fragment>
                ) : (
                    <div className={"no-content"}>Aucune meilleure vidéo</div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userTopVideos: state.userTopVideos.data,
        userTopVideosLoading: state.userTopVideos.loading,
        userTopVideosInitialized: state.userTopVideos.initialized,
        userTopVideosTotal: state.userTopVideos.data && state.userTopVideos.data.length,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserTopVideos,
    resetUserTopVideos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileBestVideos);
